// @flow
import type {RawDraftContentState} from 'draft-js/lib/RawDraftContentState';
import type {EntityType} from 'src/types/ats-entities';
import type {ThunkAction} from 'src/reducers';
import type {UseCase, ChatbotMedium, Id, FlowConfig} from 'src/types/chatbot';

import {pushModal} from 'src/action-creators/modal';
import {omitNil} from 'src/utils/object';
import * as api from 'src/utils/redux-api-v2';


export const createFlow =
  ({
    name = 'New Flow - ' + new Date().toLocaleString(),
    ...flow
  }: $Shape<{
    name?: string,
    use_case: UseCase,
    anchor_entity_type: EntityType,
    medium: ChatbotMedium,
  }> = {}): ThunkAction<> =>
  (dispatch) => {
    return dispatch(
      api.post(
        'chatbot/flows',
        omitNil({
          name,
          ...flow,
        }),
      ),
    );
  };

export const updateFlowConfig =
  (flowId: Id, config: FlowConfig): ThunkAction<> =>
  (dispatch) =>
    dispatch(api.put(`chatbot/flows/${flowId}/config`, config));

export const copyFlow =
  (flowId: Id): ThunkAction<> =>
  (dispatch) =>
    dispatch(api.post(`chatbot/flows/${flowId}/copy`));

export const archiveFlow =
  (flowId: Id, force: boolean = false): ThunkAction<> =>
  (dispatch) =>
    dispatch(api.post(`chatbot/flows/${flowId}/archive`, {force}));
